import { render, staticRenderFns } from "./MealStyle.vue?vue&type=template&id=3ad897b0&"
import script from "./MealStyle.vue?vue&type=script&lang=js&"
export * from "./MealStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports